/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import _ from 'lodash';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import * as ActionTypes from './ActionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

// dispatch function for tab data for request Invoices qtr not paid screen
export const hcpcsCodeClaimSearchObj = (data) => ({
  type: ActionTypes.GET_HCPCS_CODE_CLAIM_SEARCH_OBJ,
  screenData: data,
});
// Display Data clear issue.
export const dispatchDisplayObjHcpcsClaims = (data) => ({
  type: ActionTypes.SET_DISPLAY_OBJ_HCPCS_CLAIMS,
  payload: data,
});

// loading tHE api data
// export const setLoading = (value) => ({
//   type: ActionTypes.IS_LOADING,
//   isLoading: value,
// });
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

// To get plantype data
export const getPlanTypeValues = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};

//  get rebate programe funnction
export const getRebateProgrameList = (value) => (dispatch) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch((response) => {});
};

//  error msg dispatch function
export const dispatchErrorMsgHcpcsCode = (data) => ({
  type: ActionTypes.GET_ERROR_MSG_HCPCS_CODE,
  payload: data,
});

// dispatch dispute Code
export const dispatchSortBy = (data) => ({
  type: ActionTypes.DISPLAY_SORT_BY,
  payload: data,
});
export const dispatchQtrRange = (data) => ({
  type: ActionTypes.DISPATCH_QTR_RANGE,
  payload: data,
});
export const dispatchAllMfgChecked = (data) => ({
  type: ActionTypes.DISPATCH_ALL_MFG_CHECKED,
  payload: data,
});

// Manufactuerer Name Display
export const getManufactureName = (value) => ({
  type: ActionTypes.GET_MANUFACTURER_NAME_ACT,
  allManufacturer: value,
});
// Manufacturer ID display
export const getManufactureID = (value) => ({
  type: ActionTypes.GET_MANUFACTURER_ID_ACT,
  manufactureWithIds: value,
});
// To pass data from req screen to display screen
export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_RESULT_HCPCS,
  payload: data,
});

// select option dispatch
export const getSelectedOption = (data) => ({
  type: ActionTypes.SELECT_OPTION,
  payload: data,
});
// dispatch Manufacturer list
const setManufactureList = (data) => ({
  type: ActionTypes.SET_MANUFACTURERS_LIST,
  payload: data,
});

// get manufacturer list
export const getManufacturerList = (values) => (dispatch) => {
  // dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_MANUFACTURERS_DATA_LIST, values)
    .then((response) => {
      // dispatch(setLoading(false));
      return dispatch(
        setManufactureList(response?.data?.rebatePercentOfSpendMfgGridVO)
      );
    })
    .catch((response) => {
      // dispatch(setLoading(false));
      dispatch(setManufactureList([]));
    });
};

// This action show error message for 5 sec for no contract exists
const showNoDataMessage = () => async (dispatch) => {
  // setTimeout(() => {
    // dispatch(dispatchErrorMsgHcpcsCode([]));
  // }, 5000);
  dispatch(
    dispatchErrorMsgHcpcsCode([
      {
        field: 'noData',
        message: NO_DATA,
      },
    ])
  );
//  await Promise.resolve();
 // dispatch(dispatchErrorMsgHcpcsCode([]));
};

// dispatch Maanufacturer list for Detail  Report Quarter Data.

export const setDetailReportTypeQtr = (data) => ({
  type: ActionTypes.SET_DETAIL_REPORT_TYPE_QUARTER,
  payload: data,
});

// get manufacturer list acc to detail report
export const getDetailReportTypeQtrList =
  (values, selectedRows) => (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setDetailReportTypeQtr([]));
    return axios
      .post(serviceEndPoint.HCPCS_GET_DETAIL_REPORT_QUARTER, values)
      .then((response) => {
        // dispatch(setLoading(false));
        if (
          response?.data?.hcpcsCodeClaimsPaidDetailsQtrReportVO?.length === 0
        ) {
          //if (selectedRows?.length === 1) {
            dispatch(showNoDataMessage());
         // }
        } else {
          dispatch(
            setDetailReportTypeQtr(
              response?.data?.hcpcsCodeClaimsPaidDetailsQtrReportVO
            )
          );
        }
      })
      .catch((response) => {
        // dispatch(setLoading(false));
        dispatch(setDetailReportTypeQtr([]));
      });
  };

// dispatch Maanufacturer list for Summary  Report Quarter Data.

export const setSummaryReportTypeQtr = (data) => ({
  type: ActionTypes.SET_SUMMARY_REPORT_TYPE_QUARTER,
  payload: data,
});

// get manufacturer list acc to detail report
export const getSummaryReportTypeQtrList = (values) => (dispatch) => {
  // dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.HCPCS_GET_SUMMARY_REPORT_QUARTER, values)
    .then((response) => {
      // dispatch(setLoading(false));
      if (response?.data?.hcpcsCodeClaimsPaidRequestVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(
          setSummaryReportTypeQtr(response?.data?.hcpcsCodeClaimsPaidRequestVO)
        );
      }
    })
    .catch((response) => {
      // dispatch(setLoading(false));
      dispatch(setSummaryReportTypeQtr([]));
    });
};

// dispatch Maanufacturer list for Detail  Report NDC Data.

export const setDetailReportTypeNdc = (data) => ({
  type: ActionTypes.SET_DETAIL_REPORT_TYPE_NDC,
  payload: data,
});

// get manufacturer list acc to detail NDC report
export const getDetailReportTypeNdcList =
  (values, selectedRows) => (dispatch) => {
    // dispatch(setLoading(true));
    dispatch(setDetailReportTypeNdc([]));
    return axios
      .post(serviceEndPoint.HCPCS_GET_DETAIL_REPORT_NDC, values)
      .then((response) => {
        // dispatch(setLoading(false));
        if (
          response?.data?.hcpcsCodeClaimsPaidDetailsNdcReportVO.length === 0
        ) {
         // if (selectedRows?.length === 1) {
            dispatch(showNoDataMessage());
          //}
        } else {
          dispatch(
            setDetailReportTypeNdc(
              response?.data?.hcpcsCodeClaimsPaidDetailsNdcReportVO
            )
          );
        }
      })
      .catch((response) => {
        // dispatch(setLoading(false));
        dispatch(setDetailReportTypeNdc([]));
      });
  };

// dispatch Maanufacturer list for Summary  Report Quarter Data.

export const setSummaryReportTypeMfg = (data) => ({
  type: ActionTypes.SET_SUMMARY_REPORT_TYPE_MANUFACTURER,
  payload: data,
});

// get manufacturer list acc to detail report
export const getSummaryReportTypeMfgList = (values) => (dispatch) => {
  // dispatch(setLoading(true));

  return axios
    .post(serviceEndPoint.HCPCS_GET_SUMMARY_REPORT_MANUFACTURER, values)
    .then((response) => {
      // dispatch(setLoading(false));
      if (response?.data?.codeClaimsPaidSumamryMfgReportVO.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(
          setSummaryReportTypeMfg(
            response?.data?.codeClaimsPaidSumamryMfgReportVO
          )
        );
      }
    })
    .catch((response) => {
      // dispatch(setLoading(false));
      dispatch(setSummaryReportTypeMfg([]));
    });
};

// Refresh Functinality
export const refreshHCPCScodeClaims = () => ({
  type: ActionTypes.REFRESH_HCPCS_CODE_CLAIMS,
  payload: {},
});
export const refreshHCPCScodeClaimsDisplay = () => ({
  type: ActionTypes.REFRESH_HCPCS_CODE_CLAIMS_DISPLAY,
  payload: {},
});

export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_HCPCS_CLAIMS,
  payload: value,
});

export const getSummaryReportMfgList = (values) => (dispatch) => {
  return axios
    .post(serviceEndPoint.HCPCS_MFG_DATA_LIST, values)
    .then((response) => response.data?.mfgs)
    .catch((response) => []);
};

export const setExportToAllData = (data) => ({
  type: ActionTypes.EXPORT_TO_ALL_DATA,
  exportToAllList: data,
});
export const getExportToAllData = (values, type) => (dispatch) => {
  let url = '';
  if (type === 'NDC') {
    url = serviceEndPoint.HCPCS_GET_DETAIL_REPORT_NDC;
  } else {
    url = serviceEndPoint.HCPCS_GET_DETAIL_REPORT_QUARTER;
  }
  dispatch(setExportToAllData([]));
  return axios
    .post(url, values)
    .then((response) => {
      dispatch(
        setExportToAllData(
          type === 'NDC'
            ? response?.data?.hcpcsCodeClaimsPaidDetailsNdcReportVO
            : response?.data?.hcpcsCodeClaimsPaidDetailsQtrReportVO
        )
      );
      return type === 'NDC'
        ? response?.data?.hcpcsCodeClaimsPaidDetailsNdcReportVO
        : response?.data?.hcpcsCodeClaimsPaidDetailsQtrReportVO;
    })
    .catch(() => {
      dispatch(setExportToAllData([]));
      return [];
    });
};
